import React, { useEffect, useRef } from "react";
import { SiteLink } from "./routes";

/* ──────────────────────────────────────────────
   Cookie banner — shown until the visitor chooses, and
   again from the footer "Cookie settings" link. Reject and
   Allow carry equal weight; nothing optional loads first.
   ────────────────────────────────────────────── */
export default function CookieBanner({ open, current, onChoose }) {
  const ref = useRef(null);

  // Move focus to the banner when it is reopened from "Cookie settings"
  useEffect(() => {
    if (open && current) ref.current?.focus();
  }, [open, current]);

  if (!open) return null;

  return (
    <div
      ref={ref}
      className="cookieBanner"
      role="region"
      aria-label="Cookie choices"
      tabIndex={-1}
    >
      <div className="cookieBannerInner">
        <div className="cookieBannerText">
          <div className="cookieBannerTitle">Cookies on this website</div>
          <p>
            We'd like to use HubSpot analytics — cookies and a browser identifier — to understand how
            visitors use our website. They stay off unless you allow them. We store your choice in your
            browser so we don't ask again for six months.{" "}
            <SiteLink to="cookies" className="cookieBannerLink">Cookie policy</SiteLink>
          </p>
          {current && (
            <p className="cookieBannerStatus">
              Current choice: analytics cookies {current.analytics ? "allowed" : "rejected"}.
            </p>
          )}
        </div>
        <div className="cookieBannerActions">
          <button type="button" className="btn cookieBtn" onClick={() => onChoose(false)}>
            Reject analytics
          </button>
          <button type="button" className="btn cookieBtn" onClick={() => onChoose(true)}>
            Allow analytics
          </button>
        </div>
      </div>
    </div>
  );
}
